export default __webpack_public_path__ + "static/media/video1.173b9f9b.mp4";